/* Module-scope registry for in-flight submissions.
   Promises must never travel through router state (history.pushState
   structured-clones state and Promises are not clone-able). */
const pending = {};

export function setPendingSubmit(token, promise) {
  pending[token] = promise;
}

export function takePendingSubmit(token) {
  const p = pending[token];
  delete pending[token];
  return p;
}
